import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { MdMessage } from "react-icons/md";
import * as yup from "yup";
import useAxios from "axios-hooks";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { activeConnectorState } from "atoms/activeConnectorState";
import { toastState } from "atoms/toastState";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";

const TriggerMessage = ({ refresh, connector: connectorProp, inline = false }) => {
  const activeConnectorFromState = useRecoilValue(activeConnectorState);
  const activeConnector = connectorProp ?? activeConnectorFromState;

  const setToast = useSetRecoilState(toastState);
  const [{ data, loading, error }, execute] = useAxios(
    { method: "POST", url: "/api/ocpp16/triggerMessage" },
    { manual: true }
  );
  const validationSchema = yup.object().shape({
    Message: yup.string().required("Please select Message"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const triggerOptions = [
    "BootNotification",
    "DiagnosticsStatusNotification",
    "FirmwareStatusNotification",
    "Heartbeat",
    "MeterValues",
    "StatusNotification",
  ];

  const controllers = [
    {
      name: "Message",
      label: "Message Trigger",
      type: "select",
      helperText: "Select one message trigger",
    },
  ].map((ele) => {
    const options = triggerOptions.map((el, index) => (
      <option value={el} key={index}>
        {el}
      </option>
    ));
    return (
      <Controller
        name={ele.name}
        control={control}
        render={({ field }) => (
          <FormControl as="fieldset" maxW="100%" isInvalid={errors[ele.name]}>
            <FormLabel as="legend" fontSize="sm" fontWeight={600} mb={1}>
              {ele.label}
            </FormLabel>
            {ele.type === "select" && (
              <Select
                required
                placeholder="Select Message Trigger"
                {...field}
                borderRadius="lg"
                border="1px solid rgba(245, 125, 54, 0.25)"
                fontSize="sm"
                _focus={{
                  borderColor: "#f57d36",
                  boxShadow: "0 0 0 1px #f57d36",
                }}
                h="38px"
              >
                {options}
              </Select>
            )}
            <FormHelperText>{ele?.helperText}</FormHelperText>
            <FormErrorMessage mb={"20px"}>
              {errors[ele.name] && errors[ele.name].message}
            </FormErrorMessage>
          </FormControl>
        )}
      />
    );
  });

  const operation = async () => {
    const formValues = getValues();
    let body = {};
    body["EvseSerialId"] = activeConnector.EvseSerialId;
    body["StationId"] = activeConnector.EvseId;
    body["Trigger"] = formValues.Message;
    try {
      const response = await execute({ data: body });
      setToast({
        isOpen: true,
        title: "Message Triggered SSuccessfully",
        description: response.data.data.Message,
        status: "success",
      });
    } catch (error) {
      const err = error?.response?.data?.error;
      logger.log(error);
      setToast({
        isOpen: true,
        title: "Error occured when Triggering Message",
        description: err ? err : null,
        status: "error",
      });
    }
    refresh();
  };
  const content = (
    <>
      <Text fontWeight={700} fontSize="sm" color="gray.700" mb={2.5}>
        Trigger Message
      </Text>
      <Stack spacing={2.5} mb={3} w="100%">
        {controllers}
      </Stack>
      <Button
        alignSelf="flex-end"
        borderRadius="md"
        size="sm"
        h="36px"
        fontSize="sm"
        textColor={"white"}
        backgroundColor="#f57d36"
        _hover={{ backgroundColor: "whatsapp.600" }}
        rightIcon={<MdMessage size={13} />}
        onClick={handleSubmit(operation)}
        isLoading={loading}
      >
        Send Trigger
      </Button>
    </>
  );

  return loading ? (
    <LoadingSpinner />
  ) : inline ? (
    <Stack align="stretch">{content}</Stack>
  ) : (
    <Card alignItems="stretch" pt={0} px={0} pb={0}>
      {content}
    </Card>
  );
};

export default TriggerMessage;
